import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, STUDENT_PAYMENTS_PRINCIPAL } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const EXTERNAL_PAYMENTS = GLOBAL_STATE

export const { reducer: paymentsReducer } = createSlice({
  name: EXTERNAL_PAYMENTS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.paymentsPrincipal.pending, state => {
        state[STUDENT_PAYMENTS_PRINCIPAL].loading = true
      })
      .addCase(actionCreators.paymentsPrincipal.rejected, (state, action) => {
        state[STUDENT_PAYMENTS_PRINCIPAL].loading = false
        state[STUDENT_PAYMENTS_PRINCIPAL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.paymentsPrincipal.fulfilled, (state, action) => {
        state[STUDENT_PAYMENTS_PRINCIPAL].loading = false
        state[STUDENT_PAYMENTS_PRINCIPAL].error = null
        state[STUDENT_PAYMENTS_PRINCIPAL].data = action.payload
      })

    builder.addCase(actionCreators.paymentsPrincipalClear, state => {
      state[STUDENT_PAYMENTS_PRINCIPAL] = defaultState()
    })
  },
})
